// @flow
import React from 'react';
import { get, isEmpty } from 'lodash';

import { COLORS } from 'Components/utils/color/colors.js';
import { ICONS } from 'Components/utils/icon/icons.js';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';

type Props = {
  icon:
    | typeof ICONS.DATE
    | typeof ICONS.USERS
    | typeof ICONS.TRANSPORT
    | typeof ICONS.NO_TRANSPORT
    | typeof ICONS.BOAT
    | typeof ICONS.TRAIN,
  infos?: {
    text1: string,
    highlightText1?: string,
    text2?: string,
    highlightText2?: string,
  },
};

function renderDetail(text, highlightText, style) {
  if (isEmpty(text) && isEmpty(highlightText)) {
    return null;
  }

  return (
    <div className="rtl:text-left" style={style}>
      <span data-testid="TravelDetail-label">{text}</span>
      <span> </span>
      <strong data-testid="TravelDetail-bold" className="text-blue">
        {highlightText}
      </strong>
    </div>
  );
}

export function TravelDetail(props: Props) {
  return (
    <div className="TravelDetail flex items-center py-2 sm:justify-center sm:w-full">
      <Icon
        className="mx-4 sm:m-0 md:mx-2 align-top flex-shrink-0"
        color={COLORS.BLUE}
        name={props.icon}
        width="1.75rem"
      />
      {!isEmpty(props.infos) ? (
        <div
          className="mx-2 w-full align-top sm:align-middle sm:w-auto"
          data-testid="TravelDetail-texts"
        >
          {renderDetail(get(props, 'infos.text1'), get(props, 'infos.highlightText1'))}
          {renderDetail(get(props, 'infos.text2'), get(props, 'infos.highlightText2'))}
        </div>
      ) : null}
    </div>
  );
}
